module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [(_vm.isEditing) ? _c('h2', [_vm._v("Redigér ansættelsesskabelon")]) : _c('h2', [_vm._v("Opret ny ansættelsesskabelon")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "input_title",
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "F.eks. Lærervikar"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group d-input-group--toggler",
    class: {
      'd-input-group--toggler--active': _vm.localManualSalary
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setIsManualSalary(!_vm.localManualSalary)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skal indberettes som vikarløn")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.localManualSalary
    }
  })], 1), _vm._v(" "), (_vm.localManualSalary) ? _c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Standard lønkode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salaryCodeId),
      expression: "salaryCodeId"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n              " + _vm._s(salaryCode.name) + " (" + _vm._s(salaryCode.code) + ")\n            ")])
  })], 2)]), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Standard omkostningsted")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.omkostningssted),
      expression: "omkostningssted"
    }],
    staticClass: "do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.omkostningssted = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      key: costCenter.code,
      domProps: {
        "value": costCenter.code
      }
    }, [_vm._v("\n              " + _vm._s(costCenter.title) + "\n            ")])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [(_vm.isEditing) ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isDeleting
    },
    on: {
      "click": _vm.deleteEmploymentTemplate
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
        'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEditing ? 'Opdatér' : 'Opret') + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bccd80f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/DoEmploymentTemplate.vue
// module id = 1804
// module chunks = 1